import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { ISystemSettings } from "@/Settings/types/Common/model";
import { QueryClient } from "@tanstack/react-query";

export const systemSettingsCb = ({
	response,
	queryClient,
	locationId,
}: {
	response: GraphqlQueryResponse<"onUpdateSystemSettings", ISystemSettings>["data"];
	queryClient: QueryClient;
	locationId: string;
}) => {
	const resultMutation: Record<string, any> = response?.data?.onUpdateSystemSettings ?? {};
	const objectKeys = Object.keys(resultMutation);
	objectKeys.forEach((key) => {
		if (key !== "_id" && key !== "locationId" && resultMutation[key] !== null) {
			queryClient.setQueryData(["systemSettings", locationId], (oldData: Record<string, any>) => {
				const newData = { ...oldData };
				if (key === "chargebackLimit" || key === "commissionCyclesPerMonth") {
					newData[key].value = resultMutation[key].value;
				} else {
					newData[key] = resultMutation[key];
				}
				return newData;
			});
		}
	});
};
